import React, { useState } from "react";
import { api } from "../lib/api";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { Label } from "../components/ui/label";
import { ShieldCheck } from "lucide-react";
import { toast } from "sonner";

export default function Admin() {
  const [email, setEmail] = useState("");
  const [secret, setSecret] = useState("");
  const [days, setDays] = useState(730);
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/admin/comp-user", {
        email,
        admin_secret: secret,
        duration_days: parseInt(days) || 730,
        plan_name: "founding_member_free",
      });
      setResult(data);
      toast.success(`Comp'd ${data.email} until ${data.expires}`);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Failed");
      setResult(null);
    } finally { setLoading(false); }
  };

  return (
    <div className="max-w-md mx-auto px-5 py-16">
      <div className="bg-white border border-[#E2DCD0] rounded-xl p-8">
        <div className="flex items-center gap-2 mb-2">
          <ShieldCheck className="w-6 h-6 text-[#314A3E]" />
          <h1 className="text-2xl font-bold tracking-tight" style={{ fontFamily: "Outfit" }}>Admin · Comp User</h1>
        </div>
        <p className="text-sm text-stone-600 mb-6">Grant a user a free founding-member subscription. Requires the admin secret.</p>

        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label>User email</Label>
            <Input data-testid="admin-email" type="email" required value={email} onChange={e => setEmail(e.target.value)} placeholder="kate@kootenayhomepros.ca" />
          </div>
          <div>
            <Label>Days of access</Label>
            <Input data-testid="admin-days" type="number" value={days} onChange={e => setDays(e.target.value)} />
          </div>
          <div>
            <Label>Admin secret</Label>
            <Input data-testid="admin-secret" type="password" required value={secret} onChange={e => setSecret(e.target.value)} placeholder="Required" />
          </div>
          <Button data-testid="admin-comp-btn" type="submit" disabled={loading} className="w-full bg-[#314A3E] hover:bg-[#243a30] text-white">
            {loading ? "Working…" : "Grant Free Subscription"}
          </Button>
        </form>

        {result && (
          <div className="mt-6 p-4 bg-[#F0EBE1] rounded-lg text-sm">
            <div className="font-semibold text-[#314A3E]">✓ Comp applied</div>
            <div className="text-stone-700 mt-1">{result.email} · plan: {result.plan} · expires: {result.expires}</div>
          </div>
        )}
      </div>
    </div>
  );
}
